import { ImageName } from "@mcleod/images";
import { ComponentProps, ComponentPropDefinitionUtil } from "../../base/ComponentProps";
import { ComponentPropDefinitions } from "../../base/ComponentProps";
import { PropType } from "../../base/PropType";
import { ImagePropDefinitions } from "../image/ImageProps";

export interface TreeProps extends ComponentProps {
  nodeLeafImageName: ImageName;
  nodeDefaultImageName: ImageName;
  nodeExpandedImageName: ImageName;
  nodeCollapsedImageName: ImageName;
}

let treePropDefs: ComponentPropDefinitions;

export class TreePropDefinitions {
  public static getDefinitions(): ComponentPropDefinitions {
    if (treePropDefs == null) {
      treePropDefs = {
        ...ComponentPropDefinitionUtil.getComponentPropertyDefinitions(),
        nodeLeafImageName: {type: PropType.string, editor: ImagePropDefinitions.imagePropertyEditor, description: "This specifies the default image to use for leaf nodes in this Tree"},
        onChange: { type: PropType.event, category: "Events", addListenerMethod: "addChangeListener", removeListenerMethod: "removeChangeListener", description: "This specifies a function to be called when the a new value is selected in the Tree." },
      }
      ComponentPropDefinitionUtil.populateComponentPropNames(treePropDefs);
    }
    return treePropDefs;
  }
}
